import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SupportModal from './SupportModal';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showSupportModal, setShowSupportModal] = useState(false);

  return (
    <footer className="bg-gray-900 text-white py-12 px-4 mt-auto">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-4 block">
              Hairalyze
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Hair analysis platform providing personalized hair care recommendations and expert styling advice, with AI precision.
            </p>

          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors text-sm">
                  FAQ
                </Link>
              </li>

              <li>
                <Link to="/signup" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Get Started
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => setShowSupportModal(true)}
                  className="text-gray-400 hover:text-white transition-colors text-sm text-left"
                >
                  Contact Us
                </button>
              </li>
              <li>
                <a
                  href="mailto:contact@hairalyzer.com"
                  className="text-gray-400 hover:text-white transition-colors text-sm"
                >
                  contact@hairalyzer.com
                </a>
              </li>
              <li>
                <span className="text-gray-400 text-sm">
                  Response: 24 hours
                </span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Terms of Use
                </Link>
              </li>
              <li>
                <span className="text-gray-400 text-sm">
                  GDPR Compliant
                </span>
              </li>
              <li>
                <span className="text-gray-400 text-sm">
                  Secure & Encrypted
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} Hairalyze. All rights reserved.
            </div>
            <div className="flex flex-wrap items-center gap-4 text-sm">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">
                Privacy
              </Link>
              <Link to="/terms-of-use" className="text-gray-400 hover:text-white transition-colors">
                Terms
              </Link>
              <button
                onClick={() => setShowSupportModal(true)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                Contact
              </button>
              <a
                href="mailto:contact@hairalyzer.com"
                className="text-gray-400 hover:text-white transition-colors"
              >
                contact@hairalyzer.com
              </a>
              <span className="text-gray-400">
                Made with ❤️ for beautiful hair
              </span>

            </div>
          </div>


        </div>


      </div>

      {/* Support Modal */}
      <SupportModal
        isOpen={showSupportModal}
        onClose={() => setShowSupportModal(false)}
      />
    </footer>
  );
};

export default Footer;
